/* <rr-atc> — add to cart AJAX (1 o 2 line items), toast "It's yours.",
   contador del header y sticky buy bar. Sin dependencias.
   Talla sin elegir (data-pending, snippet size-pending): el botón y la barra
   dicen "Pick a size" y al tocarlos se pide rr:need-size a rr-variant-picker.
   Piezas NUMBERED: la talla y la piedra van como propiedades de línea
   (controles asociados al formulario con el atributo form, así que FormData
   los recoge). El cupo lo pone Shopify: si ya no queda, /cart/add.js
   devuelve 422 y se dice por qué en el toast, en vez de no hacer nada. */
(() => {
  if (customElements.get('rr-atc')) return;

  // con el prefijo del idioma (/es/, /fr/…), o el carrito repinta en inglés
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // medición (docs/plan-de-medicion.md §4.5 y §4.8): talla sin elegir, barra fija, añadidos y errores
  const rr = (n, p) => window.rrTrack && window.rrTrack(n, p);

  class RRAtc extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-rr-form]');
      this.idInput = this.querySelector('[data-rr-id]');
      this.atcBtn = this.querySelector('[data-rr-atc]');
      this.atcLabel = this.querySelector('[data-rr-atc-label]');
      this.toast = this.querySelector('[data-rr-toast]');
      this.toastText = this.toast ? this.toast.textContent : '';
      this.unavailable = false;
      // talla sin elegir (snippet size-pending): el botón dice "Pick a size" y lleva a ella
      this.pending = this.hasAttribute('data-pending');

      if (this.form) {
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          const via = this.via || 'main'; // la barra fija lo marca antes de enviar
          this.via = '';
          if (this.pending) {
            document.dispatchEvent(new CustomEvent('rr:need-size'));
            rr('rr_size_prompt', { ui_area: via });
            return;
          }
          const item = { id: parseInt(this.idInput.value, 10), quantity: 1 };
          const properties = {};
          new FormData(this.form).forEach((value, key) => {
            const m = /^properties\[(.+)\]$/.exec(key);
            if (m && value !== '') properties[m[1]] = value;
          });
          if (Object.keys(properties).length) item.properties = properties;
          this.add([item], this.atcBtn);
        });
        this.setupBar();
        document.addEventListener('rr:variant', (e) => this.onVariant(e.detail.variant, e.detail.pending));
      }

      this.querySelectorAll('[data-rr-pair]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const mainInput = this.idInput || document.querySelector('[data-rr-id]');
          const main = parseInt(btn.dataset.mainId || (mainInput && mainInput.value), 10);
          const pair = parseInt(btn.dataset.pairId, 10);
          if (main && pair) this.add([{ id: main, quantity: 1 }, { id: pair, quantity: 1 }], btn, 'pair');
        });
      });

      this.querySelectorAll('[data-rr-quick]').forEach((btn) => {
        btn.addEventListener('click', () => {
          // "Stack it with" de una pieza con tallas: la talla va en su desplegable
          const select = btn.dataset.rrQuickSelect && document.getElementById(btn.dataset.rrQuickSelect);
          if (select && !select.value) {
            select.focus();
            if (select.showPicker) {
              try { select.showPicker(); } catch {}
            }
            return;
          }
          const id = select ? select.value : btn.dataset.rrQuick;
          this.add([{ id: parseInt(id, 10), quantity: 1 }], btn, 'stack_with');
        });
      });

      // La talla elegida arriba se propone en las piezas del stack que la tienen
      // (un anillo apilado va en el mismo dedo), mientras no se toque a mano.
      const sized = [...this.querySelectorAll('select[data-rr-stack-size]')];
      if (sized.length) {
        sized.forEach((s) => s.addEventListener('change', () => { s.dataset.touched = ''; }));
        document.addEventListener('rr:variant', (e) => {
          const { variant, pending } = e.detail || {};
          if (!variant || pending) return;
          sized.forEach((s) => {
            if ('touched' in s.dataset) return;
            const match = [...s.options].find((o) => o.dataset.size && variant.options.includes(o.dataset.size));
            if (match && !match.disabled) s.value = match.value;
          });
        });
      }
    }

    // source: de dónde sale el añadido si no es el botón de compra (pair, stack_with), para la medición
    async add(items, btn, source) {
      // aria-busy: mientras añade, el botón de compra conserva su color (no parpadea a desactivado)
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      }
      try {
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (res.ok) {
          this.showToast();
          const cart = await (await fetch(`${root}cart.js`)).json();
          document.querySelectorAll('[data-rr-cart-count]').forEach((el) => {
            el.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('rr:cart-updated', { detail: { cart } }));
          if (source) rr('rr_quick_add', { action: 'add', element: source }); // en element: GA4 pisa source con el UTM
        } else if (res.status === 422) {
          const inCart = await this.explainLimit(items);
          rr('rr_cart_error', { reason: inCart ? 'limit' : 'gone', ui_area: source || 'main' });
        }
      } catch {
        /* estado intacto; el checkout nativo sigue disponible */
        rr('rr_cart_error', { reason: 'network', ui_area: source || 'main' });
      }
      if (btn) {
        btn.disabled = btn === this.atcBtn ? this.unavailable : false;
        btn.removeAttribute('aria-busy');
      }
    }

    // 422: no queda más de esa pieza. O ya está todo en el carrito, o se ha
    // ido mientras se miraba la ficha.
    async explainLimit(items) {
      let inCart = false;
      try {
        const cart = await (await fetch(`${root}cart.js`)).json();
        inCart = cart.items.some((line) => items.some((i) => i.id === line.variant_id));
      } catch {
        /* sin carrito, se dice que se ha ido */
      }
      const msg = inCart ? this.dataset.msgLimit : this.dataset.msgGone;
      if (msg) this.showToast(msg);
      return inCart;
    }

    showToast(text) {
      if (!this.toast) return;
      this.toast.textContent = text || this.toastText;
      this.toast.hidden = false;
      clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.toast.hidden = true;
      }, text ? 4200 : 2600);
    }

    onVariant(variant, pending) {
      this.pending = Boolean(pending);
      if (this.idInput) this.idInput.value = variant.id;
      this.unavailable = !pending && !variant.available;
      if (this.atcBtn && this.atcLabel) {
        this.atcBtn.disabled = this.unavailable;
        if (pending) this.atcLabel.textContent = this.dataset.labelPick;
        else this.atcLabel.textContent = variant.available
          ? `${this.dataset.labelAdd} — ${variant.price}`
          : this.dataset.labelSoldout;
      }
      const barBtn = document.querySelector('[data-rr-bar-atc]');
      if (barBtn && this.dataset.labelPick) {
        barBtn.textContent = pending ? this.dataset.labelPick : this.dataset.labelAdd;
        barBtn.disabled = this.unavailable;
      }
      const size = document.querySelector('[data-rr-bar-size]');
      if (size) size.textContent = pending ? '' : ` · ${variant.title}`;
      // el precio grande de la ficha también (la cadena del colgante: €229 → €289)
      document.querySelectorAll('[data-rr-price], [data-rr-bar-price]').forEach((el) => {
        el.textContent = variant.price;
      });
      document.querySelectorAll('[data-rr-pair][data-main-id]').forEach((btn) => {
        btn.dataset.mainId = variant.id;
      });
    }

    setupBar() {
      const bar = document.querySelector('[data-rr-bar]');
      if (!bar) return;
      const btn = bar.querySelector('[data-rr-bar-atc]');
      if (btn) {
        btn.addEventListener('click', () => {
          rr('rr_sticky_bar', { action: 'click' });
          this.via = 'sticky_bar';
          this.form.requestSubmit();
        });
      }
      // La barra sale siempre que el botón no se ve entero, por encima o por
      // debajo de la pantalla (R-03, 15 oct 2026): en la primera pantalla del
      // móvil, si el botón queda bajo el borde, la barra lo pone a mano. Como
      // arriba y abajo dan lo mismo, un salto de scroll que lo pase de un lado
      // al otro sin pisar la pantalla no deja la barra en un estado viejo.
      // Con el botón aún por debajo, espera a que la talla quede por encima de
      // ella (16 oct 2026: a 360×780 tapaba la última fila de tallas).
      const picker = document.querySelector('rr-variant-picker');
      let hidden = false;
      let footerOn = false;
      const update = () => {
        let show = hidden && !footerOn;
        if (show && picker && this.form.getBoundingClientRect().top > 56) {
          const p = picker.getBoundingClientRect();
          if (p.bottom > innerHeight - bar.offsetHeight && p.top < innerHeight) show = false;
        }
        bar.classList.toggle('is-visible', show);
        if (show && !this.barSeen) {
          this.barSeen = true;
          rr('rr_sticky_bar', { action: 'shown' });
        }
      };
      // Con el pie en pantalla la barra se va: tapaba su línea legal (Privacy ·
      // Shipping · Returns) y el selector de país, sin forma de tocarlos (18 oct 2026).
      const footer = document.querySelector('footer');
      if (footer) {
        new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            footerOn = en.isIntersecting;
          });
          update();
        }).observe(footer);
      }
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((en) => {
            hidden = en.intersectionRatio < 0.99;
          });
          update();
        },
        // arriba, menos lo que tapa la cabecera fija
        { rootMargin: '-56px 0px 0px 0px', threshold: [0, 0.99, 1] }
      );
      io.observe(this.form);
      if (picker) {
        new IntersectionObserver(update, {
          rootMargin: `0px 0px -${bar.offsetHeight || 80}px 0px`,
          threshold: [0, 0.5, 0.99, 1],
        }).observe(picker);
      }
    }
  }

  customElements.define('rr-atc', RRAtc);
})();
